import { ObservableMap } from '@stencil/store';
import {
    handleThemeChange,
    ThemeType,
} from '@uipath/portal-shell-util';

import { EventHandlersInstanceResolver } from '../../utils/events/eventHandlersInstanceResolver';
import GlobalEventEmitter from '../../utils/events/globalEventEmitters';
import { setStoreTheme } from '../../utils/themeHelper';
import { State } from '../types/state';

export function setThemeSideEffect(store: ObservableMap<State>) {
    handleThemeChange(theme => {
        setStoreTheme(store, theme);
    });
    store.onChange('selectedTheme', (theme: ThemeType) => {
        const selectedThemeEvent = { selectedThemeId: theme };
        GlobalEventEmitter.emitThemeSelectChanged(selectedThemeEvent);
        EventHandlersInstanceResolver.Instance?.onThemeSelectChanged?.(selectedThemeEvent);
    });
}
